import React, { useRef, useState, useLayoutEffect } from 'react';

/* Тумблер фильтра: подложка-«желобок», под активным пунктом ездит фиолетовая
   капля — ширина и позиция измеряются по кнопкам, поэтому пункты могут быть
   разной длины. Пружинная кривая даёт лёгкий перелёт — тумблер «живой».
   Живёт в «Уроках курса» на «Главной» и в «Модулях и уроках» в «Статистике». */
export default function NxSwitch({ value, onChange, options }) {
  const trackRef = useRef(null);
  const btnRefs = useRef({});
  const [thumb, setThumb] = useState(null);

  useLayoutEffect(() => {
    const el = btnRefs.current[value];
    const track = trackRef.current;
    if (!el || !track) return;
    setThumb({ x: el.offsetLeft, w: el.offsetWidth });
  }, [value, options.length]);

  return (
    <div className="nx-switch" ref={trackRef} role="tablist">
      {thumb && <span className="nx-switch-thumb" style={{ transform: `translateX(${thumb.x}px)`, width: thumb.w }} />}
      {options.map(o => (
        <button
          key={o.key}
          type="button"
          role="tab"
          aria-selected={o.key === value}
          ref={el => { btnRefs.current[o.key] = el; }}
          className={`nx-switch-btn${o.key === value ? ' on' : ''}`}
          onClick={() => onChange(o.key)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
